module.exports = __webpack_public_path__ + "img/osaslogo.778a7e47.png";